module.exports = __webpack_public_path__ + "static/step5-cc4d90a4980be6bddb735a54884fddd9.png";